var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirstpageicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 20.23L22.1954 22L12 12L22.1954 2L24 3.77L15.6092 12L24 20.23Z",
    fill: "#206BB1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 20.23L10.1954 22L0 12L10.1954 2L12 3.77L3.60918 12L12 20.23Z",
    fill: "#206BB1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstpageicon);
export default __webpack_public_path__ + "static/media/firstpageicon.8818d1e35af4d67300dab7b30fd67e0b.svg";
export { ForwardRef as ReactComponent };